module.exports = __webpack_public_path__ + "168240ca5398ff27b56eacbdf547f1c5.png";